import useBackendUser from '@/hooks/useBackendUser';
import event from '@/utilites/gTag';
import { useRouter } from 'next/router';
import { useEffect, useState, useRef } from 'react';

export default function useRecordUserSession() {
  const user = useBackendUser();
  const { locale } = useRouter();
  const intervalRef = useRef<NodeJS.Timeout | null>(null);

  // Verifica si estamos en el cliente antes de acceder a localStorage
  const [elapsedTime, setElapsedTime] = useState(() => {
    if (typeof window !== 'undefined') {
      return Number(localStorage.getItem('session_time')) || 0;
    }
    return 0;
  });

  useEffect(() => {
    if (typeof window === 'undefined') return; // No ejecutar en el servidor

    const startTimer = () => {
      if (intervalRef.current) return;

      intervalRef.current = setInterval(() => {
        setElapsedTime((prevTime) => {
          const newTime = prevTime + 1;
          localStorage.setItem('session_time', String(newTime));

          const sessionRecorded =
            localStorage.getItem('session_recorded') === 'true';
          if (newTime >= 60 && !sessionRecorded) {
            event(
              'min_1_session_web',
              {
                event_category: 'interaction',
                device: 'Website',
              },
              { userId: user.data?.id, lang: locale }
            );

            localStorage.setItem('session_recorded', 'true'); // Evita eventos duplicados
          }

          return newTime;
        });
      }, 1000);
    };

    const stopTimer = () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
      }
    };

    const handleVisibilityChange = () => {
      if (document.visibilityState === 'visible') {
        startTimer();
      } else {
        stopTimer();
      }
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);

    if (document.visibilityState === 'visible') {
      startTimer();
    }

    return () => {
      stopTimer();
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, [locale, user.data?.id]);

  return elapsedTime;
}
